import React from 'react';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import { SPAThemeScope } from '../SysadminSPA/shared/SPAThemeScope';
import ContentRail, { ContentRailProps } from './ContentRail';

// AIDEV-NOTE: The sysadmin content rail mounted beside legacy content-view pages (see
// layouts/_sysadmin_content_rail). Same legacy-mount pattern as admin/UserSearch, but pinned to the
// dark token set so it reads as one strong frame beside the light page. No router — every link is
// a full reload.
const THEME_CLASS = 'spa-theme-dark';

const LegacyContentRail = (props: ContentRailProps) => (
  <ReactQueryProvider>
    <SPAThemeScope className={THEME_CLASS}>
      <div className={`${THEME_CLASS} tw-h-full`}>
        <ContentRail {...props} />
      </div>
    </SPAThemeScope>
  </ReactQueryProvider>
);

export default LegacyContentRail;
